export const TIME_SLOTS_SHOW_COUNT = 11;

export const APPOINTMENT_SETTINGS_TYPE_REGION = 1;
export const APPOINTMENT_SETTINGS_TYPE_ONLINE = 2;

export const THANKS_MODAL_AUTO_CLOSE_DELAY = 4000;

export const APPOINTMENT_SUCCESS_TITLE = 'Спасибо за обращение!';
export const APPOINTMENT_SUCCESS_TEXT =
  'Мы свяжемся с вами для подтверждения записи в течение 15 минут';
